<template>
  <footer class="footer">
    <div class="content has-text-centered has-text-white">
      <p>
        Copyright &copy; 2020 Effigon
        <b v-if="$route.path === '/'">
          | <a class="has-text-white" href="/#" v-scroll-to="'#contact'">
            {{ $t('footer_contact') }}
          </a> |
        </b>
        <b v-else>
          | <router-link :to="{ name: 'home'}" class="has-text-white">
            {{ $t('footer_contact') }}
          </router-link> |
        </b>
        <b> <router-link :to="{ name: 'legalNotice'}" class="has-text-white">
          {{ $t('footer_legal_notice') }}</router-link> |</b>
        <b> <router-link :to="{ name: 'privacyPolicy'}" class="has-text-white">
          {{ $t('footer_privacy_policy') }}</router-link></b>

      </p>
    </div>
  </footer>
</template>

<script>

export default {
  name: 'Footer',
};

</script>
<style>
</style>
